// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2yxJt","emails":"CreateEditClinics_emails__3Q5bh","emailTagLabel":"CreateEditClinics_emailTagLabel__1bh0U"};